import { render } from "./designAttachment.vue?vue&type=template&id=33837eb4&scoped=true"
import script from "./designAttachment.vue?vue&type=script&lang=js"
export * from "./designAttachment.vue?vue&type=script&lang=js"

import "./designAttachment.vue?vue&type=style&index=0&id=33837eb4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33837eb4"]])

export default __exports__